import type { FaireProductEntity } from "../../entity_types/product";

export const p_ubceywhbbb: FaireProductEntity = {
  token: "p_ubceywhbbb",
  type: "product",
  name: "M8552 SKATE PARK graphic  tee",
  brandToken: "b_7t768kwdvz",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ab14d6b65cdf9c259d3f41b8ba297257ff3965e55587626056b1d682d1eb2a89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71c538fc7e82740dafddf02bf00bfc4467810a6336b3989213f983f690c87ac4.jpeg",
    "https://cdn.faire.com/fastly/f466702b6fec775e3d88bf067729b3e698c9eacae3688eafd5657866c0d8e223.jpeg",
    "https://cdn.faire.com/fastly/7bad1c09fa24a070cef852fc078ccec40298d07bd8c76999013441c51e13c2b4.jpeg",
    "https://cdn.faire.com/fastly/aa041a550698742996c33e21431bd481b3a4c3e0acdbda9e70aff3212da07d52.jpeg",
  ],
  priceDollars: 16.56,
  description:
    "Our fitted Unisex Cotton tee is made from an exceedingly soft 100% ring spun cotton. It features a crew neckline with hemmed sleeves and bottom for durability. Preshrunk for your convenience! Printed in the USA. Made with 100% Ring Spun Cotton.\n-S-3XL AVAILABLE\n-Other colors are also available\n-Please write it down in the memo when you make a purchase .\n-ECO FRIENDLY INKS",
  tags: [],
  msrpDollars: 33.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:38.038Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
